import { DndContext } from '@dnd-kit/core';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProposalProductItemType } from '@econtractor/types';
import useSortableTableDnd from '../model/useSortableTableDnd';
import ProductsTableBody from './ProductsTableBody';
import useProductsTable from './model/useProductsTable';

interface ProductsTableProps {
    products: ProposalProductItemType[];
    rate: number;
    localeNs: string;
    disabled: boolean;
    onChange: (products: ProposalProductItemType[]) => void;
}

const ProductsTable = ({ products, rate, localeNs, disabled, onChange }: ProductsTableProps) => {
    const { t } = useTranslation([localeNs]);
    const table = useProductsTable({ products, rate, onChange });
    const dnd = useSortableTableDnd({
        onDragStart: table.clearInlineEdits,
        onReorder: table.reorderByIds,
    });

    const tableNode = (
        <div className="proposal-products-table-wrap">
            <Table size="sm" className="ComingTable ProposalItemsTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        {!disabled ? <td className="head-drag" /> : null}
                        <td className="head-name">{t('edit.products.tableProduct')}</td>
                        <td className="head-source">{t('edit.products.tableSource')}</td>
                        <td className="head-price">{t('edit.products.tablePrice')}</td>
                        <td className="head-count text-end">{t('edit.products.tableCount')}</td>
                        {!disabled ? <td className="head-action text-end">{t('edit.products.tableActions')}</td> : null}
                    </tr>
                </thead>
                <ProductsTableBody
                    products={products}
                    rate={rate}
                    localeNs={localeNs}
                    disabled={disabled}
                    table={table}
                    sortable={!disabled}
                />
            </Table>
        </div>
    );

    if (disabled) return tableNode;

    return (
        <DndContext
            sensors={dnd.sensors}
            collisionDetection={dnd.collisionDetection}
            onDragStart={dnd.handleDragStart}
            onDragEnd={dnd.handleDragEnd}
        >
            {tableNode}
        </DndContext>
    );
};

export default ProductsTable;
